import { Route } from '@angular/router';
import { PROGRAMME_PATH } from '../mgs-path-defs';
import { programmResolver } from './programm.resolver';
import { mgsAdminGuard } from '../mgs-guards';
import { mgsIconsResolver } from '../mgs-svg-icon.helper';
import { codetableResolver } from '../codetable/codetable.resolver';

export const programmeRoute: Route = {
  path: PROGRAMME_PATH,
  title: 'Programme',
  loadComponent: () => import('./programme.component'),
  resolve: { programme: programmResolver, codetable: codetableResolver, icons: mgsIconsResolver },
  canActivate: [mgsAdminGuard]
};
